// Fragment "consult checkout" — Payment Gateway v1, Flow C (Milestone B). Patient-facing
// `consult.*` keys, per contract §9's language-law binding: `ConsultCeilingDisclosure`,
// `ConsultJoinButton`, `ConsultRoomFrame` and `ConsultBooking` all render through
// `useT("public")`.
export default {
  fr: {
    "consult.booking.title": "Confirmer votre téléconsultation",
    "consult.booking.loading": "Chargement des détails…",
    "consult.booking.missingContext": "Ce lien de confirmation est incomplet. Utilisez le lien reçu par courriel.",
    "consult.booking.redirecting": "Redirection vers le paiement…",
    "consult.booking.reasonLabel": "Motif de la consultation (optionnel)",
    "consult.booking.reasonPlaceholder": "Décrivez brièvement ce que vous souhaitez aborder — votre praticien en prendra connaissance avant la séance.",
    "consult.booking.reasonCounter": "{count}/1000",

    "consult.disclosure.noQuote": "Les détails du tarif ne sont pas disponibles pour le moment.",
    "consult.disclosure.title": "Comment cette téléconsultation est facturée",
    "consult.disclosure.rateLabel": "Tarif",
    "consult.disclosure.baseFeeLabel": "Frais de base",
    "consult.disclosure.ratePerMinute": "{amount} par minute",
    "consult.disclosure.rangeLabel": "Durée facturée",
    "consult.disclosure.rangeValue": "entre {min} et {max} minutes",
    "consult.disclosure.ceilingLabel": "Montant maximum autorisé sur votre carte",
    "consult.disclosure.ceilingValue": "Jusqu'à {amount}",
    "consult.disclosure.ceilingNote": "Vous ne serez jamais facturé plus que ce montant ; le solde inutilisé vous est libéré après la séance.",
    "consult.disclosure.noShowFee": "Des frais fixes de {amount} s'appliquent en cas d'absence.",
    "consult.disclosure.rescheduleWindow": "Reportez au moins {hours} h à l'avance pour éviter ces frais.",
    "consult.disclosure.consent": "J'ai lu et j'accepte ces conditions de facturation.",
    "consult.disclosure.continue": "Continuer vers le paiement",

    "consult.chooser.ratePerMinute": "{amount} / min",
    "consult.chooser.ceiling": "Jusqu'à {amount} pour {max} min",
    "consult.chooser.submit": "Continuer vers l'autorisation de la carte",

    "consult.join.action": "Rejoindre la consultation",
    "consult.join.reasonNone": "Le lien de connexion n'est pas encore disponible.",
    "consult.join.reasonAwaiting": "Votre paiement est en cours d'autorisation — le lien apparaîtra une fois prêt.",
    "consult.join.reasonFailed": "L'autorisation du paiement a échoué. Vérifiez votre courriel pour la suite.",
    "consult.join.reasonNotYetOpen": "Paiement autorisé — la salle ouvre le {when}.",
    "consult.join.reasonClosed": "La salle de cette consultation est fermée. Contactez le cabinet.",
    "consult.join.reasonNotPaid": "Cette consultation n'a pas encore été payée. Terminez le paiement pour y accéder.",
    "consult.join.blockCompleted": "Consultation terminée",
    "consult.join.blockNotYetOpen": "La salle ouvre le {when}.",

    "consult.reauth.explain": "L'autorisation de votre carte n'a pas pu être complétée — ce rendez-vous n'est pas encore garanti. Obtenez un nouveau lien d'autorisation pour conserver votre créneau.",
    "consult.reauth.action": "Obtenir un nouveau lien d'autorisation",
    "consult.reauth.review": "Revoir les conditions de facturation",
    "consult.reauth.noDisclosure": "Les conditions de facturation ne sont pas disponibles pour le moment — contactez votre praticien.",

    "consult.room.title": "Votre téléconsultation",
    "consult.room.practitionerTitle": "Téléconsultation",
    "consult.room.loading": "Chargement…",
    "consult.room.loadError": "Impossible de charger les détails de la consultation.",
    "consult.room.missingContext": "Les détails de cette consultation ne sont pas disponibles ici. Utilisez le lien reçu par courriel.",
    "consult.room.ceilingReminder": "Montant maximum autorisé : {amount}.",
    "consult.room.stayOnPageHint": "Gardez cette page ouverte pendant toute la séance — elle confirme votre présence en continu.",
    "consult.room.framingFallbackHint": "La vidéo ne s'affiche pas ci-dessus ?",
    "consult.room.openInNewTab": "Ouvrir dans un nouvel onglet",
    "consult.room.fullscreen.enter": "Plein écran",
    "consult.room.fullscreen.exit": "Quitter le plein écran",
    "consult.room.accessError": "Impossible d'ouvrir la salle pour le moment. Réessayez dans un instant.",
    "consult.room.status.scheduled": "En attente du début de la séance.",
    "consult.room.status.in_progress": "Séance en cours.",
    "consult.room.status.computing": "Calcul du montant en cours…",
    "consult.room.status.computed": "Montant calculé.",
    "consult.room.status.captured": "Paiement encaissé.",
    "consult.room.status.void_no_show": "Consultation annulée pour absence.",
    "consult.room.status.cancelled": "Consultation annulée.",
    "consult.room.status.readyToJoin": "Vous pouvez rejoindre la consultation.",
    "consult.room.status.waitingAuth": "En attente de l'autorisation du paiement.",
    "consult.room.status.blockCompleted": "Cette consultation est terminée.",
    "consult.room.waitingAuth.waiting": "En attente de l'autorisation du paiement — {elapsed}.",
    "consult.room.waitingAuth.confirming": "Cela prend un peu plus de temps que d'habitude. Nous confirmons le paiement auprès de l'émetteur de votre carte — gardez cette page ouverte.",
    "consult.room.duration.seconds": "{count} s",
    "consult.room.duration.minutes": "{count} min",
    "consult.room.endingSoon": "Le temps réservé se termine à {when} — il reste {remaining}.",
    "consult.room.overrun.notice": "Le temps réservé s'est terminé à {when}. La salle reste ouverte encore {remaining}.",
    "consult.room.solo.patient": "Vous êtes seul dans la salle. Si personne ne vous rejoint, vous en serez déconnecté dans {remaining}.",
    "consult.room.solo.practitioner": "Vous êtes seul dans la salle : votre client ne s'est pas encore connecté. Sans personne d'autre, vous en serez déconnecté dans {remaining}.",
    "consult.room.ejected.notice": "Vous avez été déconnecté : vous êtes resté seul trop longtemps dans la salle. Elle est toujours ouverte, vous pouvez y revenir.",
    "consult.room.ejected.rejoin": "Revenir dans la salle",
    "consult.room.closed.panel": "Le temps réservé est écoulé : cette salle est maintenant fermée.",
    "consult.room.closed.hint": "Il n'est plus possible d'y entrer. Pour poursuivre, convenez d'un nouveau rendez-vous avec le cabinet.",
    "consult.room.joinState.opensAt": "Paiement autorisé — votre salle ouvre le {when}.",
    "consult.room.joinState.blockOpensAt": "Votre salle ouvre le {when}.",
    "consult.room.joinState.blockNotPaid": "Cette consultation n'a pas encore été payée. Terminez le paiement pour y accéder.",
    "consult.room.joinState.notYetOpen": "Paiement autorisé — votre salle n'est pas encore ouverte.",
    "consult.room.joinState.closed": "La salle de cette consultation est fermée. Contactez le cabinet pour convenir d'un nouveau rendez-vous.",
    "consult.room.capReached": "Le montant maximum autorisé pour cette consultation est atteint. La facturation s'est arrêtée ; la séance peut continuer.",
    "consult.room.authFailed.practitioner": "Action de paiement requise — l'autorisation de votre client a échoué. La consultation ne peut pas démarrer tant qu'une nouvelle autorisation n'a pas été obtenue.",
    "consult.room.ended.confirmation": "Merci — vous pouvez fermer cette page en toute sécurité.",
    "consult.room.ended.backToPractice": "Retour au site du cabinet",
  },
  en: {
    "consult.booking.title": "Confirm your telehealth consult",
    "consult.booking.loading": "Loading details…",
    "consult.booking.missingContext": "This confirmation link is incomplete. Use the link from your confirmation email.",
    "consult.booking.redirecting": "Redirecting to payment…",
    "consult.booking.reasonLabel": "Reason for visit (optional)",
    "consult.booking.reasonPlaceholder": "Briefly describe what you'd like to discuss — your practitioner will see this before the session.",
    "consult.booking.reasonCounter": "{count}/1000",

    "consult.disclosure.noQuote": "Rate details aren't available right now.",
    "consult.disclosure.title": "How this telehealth consult is billed",
    "consult.disclosure.rateLabel": "Rate",
    "consult.disclosure.baseFeeLabel": "Base fee",
    "consult.disclosure.ratePerMinute": "{amount} per minute",
    "consult.disclosure.rangeLabel": "Billed duration",
    "consult.disclosure.rangeValue": "between {min} and {max} minutes",
    "consult.disclosure.ceilingLabel": "Maximum amount authorised on your card",
    "consult.disclosure.ceilingValue": "Up to {amount}",
    "consult.disclosure.ceilingNote": "You will never be charged more than this amount — the unused balance is released back to you after the session.",
    "consult.disclosure.noShowFee": "A flat fee of {amount} applies if you don't show up.",
    "consult.disclosure.rescheduleWindow": "Reschedule at least {hours}h ahead to avoid this fee.",
    "consult.disclosure.consent": "I have read and accept this billing policy.",
    "consult.disclosure.continue": "Continue to payment",

    "consult.chooser.ratePerMinute": "{amount} / min",
    "consult.chooser.ceiling": "Up to {amount} for {max} min",
    "consult.chooser.submit": "Continue to card authorisation",

    "consult.join.action": "Join the consult",
    "consult.join.reasonNone": "The join link isn't available yet.",
    "consult.join.reasonAwaiting": "Your payment is still being authorised — the link will appear once it's ready.",
    "consult.join.reasonFailed": "The payment authorisation failed. Check your email for next steps.",
    "consult.join.reasonNotYetOpen": "Payment authorised — the room opens on {when}.",
    "consult.join.reasonClosed": "This consultation's room has closed. Contact the practice.",
    "consult.join.reasonNotPaid": "This consultation hasn't been paid for yet. Complete the payment to join.",
    "consult.join.blockCompleted": "Consultation over",
    "consult.join.blockNotYetOpen": "The room opens on {when}.",

    "consult.reauth.explain": "Your card authorisation could not be completed, so this appointment isn't secured yet. Get a new authorisation link to keep your slot.",
    "consult.reauth.action": "Get a new authorisation link",
    "consult.reauth.review": "Review the billing terms",
    "consult.reauth.noDisclosure": "The billing terms aren't available right now — please contact your practitioner.",

    "consult.room.title": "Your telehealth consult",
    "consult.room.practitionerTitle": "Telehealth consult",
    "consult.room.loading": "Loading…",
    "consult.room.loadError": "Couldn't load this consult's details.",
    "consult.room.missingContext": "This consult's details aren't available here. Use the link from your confirmation email.",
    "consult.room.ceilingReminder": "Maximum amount authorised: {amount}.",
    "consult.room.stayOnPageHint": "Keep this page open for the whole session — it's what confirms your presence throughout.",
    "consult.room.framingFallbackHint": "Video not showing above?",
    "consult.room.openInNewTab": "Open in a new tab",
    "consult.room.fullscreen.enter": "Full screen",
    "consult.room.fullscreen.exit": "Exit full screen",
    "consult.room.accessError": "Couldn't open the room right now. Try again in a moment.",
    "consult.room.status.scheduled": "Waiting for the session to start.",
    "consult.room.status.in_progress": "Session in progress.",
    "consult.room.status.computing": "Computing the amount…",
    "consult.room.status.computed": "Amount computed.",
    "consult.room.status.captured": "Payment captured.",
    "consult.room.status.void_no_show": "Consult cancelled for no-show.",
    "consult.room.status.cancelled": "Consult cancelled.",
    "consult.room.status.readyToJoin": "You can join the consult.",
    "consult.room.status.waitingAuth": "Waiting for the payment authorisation.",
    "consult.room.status.blockCompleted": "This consultation is over.",
    "consult.room.waitingAuth.waiting": "Waiting for the payment authorisation — {elapsed}.",
    "consult.room.waitingAuth.confirming": "This is taking a little longer than usual. We are confirming the payment with your card provider — keep this page open.",
    "consult.room.duration.seconds": "{count} s",
    "consult.room.duration.minutes": "{count} min",
    "consult.room.endingSoon": "The booked time ends at {when} — {remaining} left.",
    "consult.room.overrun.notice": "The booked time ended at {when}. The room stays open for another {remaining}.",
    "consult.room.solo.patient": "You're on your own in the room. If nobody joins you, you'll be disconnected in {remaining}.",
    "consult.room.solo.practitioner": "You're on your own in the room — your client hasn't joined yet. With nobody else there, you'll be disconnected in {remaining}.",
    "consult.room.ejected.notice": "You were disconnected after being on your own in the room too long. The room is still open, so you can go back in.",
    "consult.room.ejected.rejoin": "Go back into the room",
    "consult.room.closed.panel": "The booked time has run out, and this room is now closed.",
    "consult.room.closed.hint": "It can't be re-entered. To carry on, arrange another appointment with the practice.",
    "consult.room.joinState.opensAt": "Payment authorised — your room opens on {when}.",
    "consult.room.joinState.blockOpensAt": "Your room opens on {when}.",
    "consult.room.joinState.blockNotPaid": "This consultation hasn't been paid for yet. Complete the payment to join.",
    "consult.room.joinState.notYetOpen": "Payment authorised — your room isn't open yet.",
    "consult.room.joinState.closed": "This consultation's room has closed. Contact the practice to arrange a new appointment.",
    "consult.room.capReached": "This consultation has reached its authorised limit. Billing has stopped; the session can continue.",
    "consult.room.authFailed.practitioner": "Payment action required — your client's authorisation failed. The consultation cannot start until a new authorisation is obtained.",
    "consult.room.ended.confirmation": "Thank you — you can safely close this page.",
    "consult.room.ended.backToPractice": "Back to the practice site",
  },
  es: {
    "consult.booking.title": "Confirme su teleconsulta",
    "consult.booking.loading": "Cargando detalles…",
    "consult.booking.missingContext": "Este enlace de confirmación está incompleto. Use el enlace de su correo de confirmación.",
    "consult.booking.redirecting": "Redirigiendo al pago…",
    "consult.booking.reasonLabel": "Motivo de la consulta (opcional)",
    "consult.booking.reasonPlaceholder": "Describa brevemente lo que desea tratar — su profesional lo verá antes de la sesión.",
    "consult.booking.reasonCounter": "{count}/1000",

    "consult.disclosure.noQuote": "Los detalles de la tarifa no están disponibles en este momento.",
    "consult.disclosure.title": "Cómo se factura esta teleconsulta",
    "consult.disclosure.rateLabel": "Tarifa",
    "consult.disclosure.baseFeeLabel": "Tarifa base",
    "consult.disclosure.ratePerMinute": "{amount} por minuto",
    "consult.disclosure.rangeLabel": "Duración facturada",
    "consult.disclosure.rangeValue": "entre {min} y {max} minutos",
    "consult.disclosure.ceilingLabel": "Monto máximo autorizado en su tarjeta",
    "consult.disclosure.ceilingValue": "Hasta {amount}",
    "consult.disclosure.ceilingNote": "Nunca se le cobrará más que este monto; el saldo no usado se le libera después de la sesión.",
    "consult.disclosure.noShowFee": "Se aplica un cargo fijo de {amount} si no se presenta.",
    "consult.disclosure.rescheduleWindow": "Reprograme con al menos {hours} h de anticipación para evitar este cargo.",
    "consult.disclosure.consent": "He leído y acepto esta política de facturación.",
    "consult.disclosure.continue": "Continuar al pago",

    "consult.chooser.ratePerMinute": "{amount} / min",
    "consult.chooser.ceiling": "Hasta {amount} por {max} min",
    "consult.chooser.submit": "Continuar a la autorización de la tarjeta",

    "consult.join.action": "Unirse a la consulta",
    "consult.join.reasonNone": "El enlace de conexión aún no está disponible.",
    "consult.join.reasonAwaiting": "Su pago aún se está autorizando — el enlace aparecerá cuando esté listo.",
    "consult.join.reasonFailed": "La autorización del pago falló. Revise su correo para los próximos pasos.",
    "consult.join.reasonNotYetOpen": "Pago autorizado — la sala abre el {when}.",
    "consult.join.reasonClosed": "La sala de esta consulta está cerrada. Contacte con la consulta.",
    "consult.join.reasonNotPaid": "Esta consulta aún no se ha pagado. Complete el pago para acceder.",
    "consult.join.blockCompleted": "Consulta finalizada",
    "consult.join.blockNotYetOpen": "La sala abre el {when}.",

    "consult.reauth.explain": "La autorización de su tarjeta no pudo completarse, así que esta cita aún no está asegurada. Obtenga un nuevo enlace de autorización para conservar su turno.",
    "consult.reauth.action": "Obtener un nuevo enlace de autorización",
    "consult.reauth.review": "Revisar las condiciones de facturación",
    "consult.reauth.noDisclosure": "Las condiciones de facturación no están disponibles en este momento — contacte a su profesional.",

    "consult.room.title": "Su teleconsulta",
    "consult.room.practitionerTitle": "Teleconsulta",
    "consult.room.loading": "Cargando…",
    "consult.room.loadError": "No se pudieron cargar los detalles de la consulta.",
    "consult.room.missingContext": "Los detalles de esta consulta no están disponibles aquí. Use el enlace de su correo de confirmación.",
    "consult.room.ceilingReminder": "Monto máximo autorizado: {amount}.",
    "consult.room.stayOnPageHint": "Mantenga esta página abierta durante toda la sesión — confirma su presencia de forma continua.",
    "consult.room.framingFallbackHint": "¿No se ve el video arriba?",
    "consult.room.openInNewTab": "Abrir en una pestaña nueva",
    "consult.room.fullscreen.enter": "Pantalla completa",
    "consult.room.fullscreen.exit": "Salir de pantalla completa",
    "consult.room.accessError": "No se pudo abrir la sala en este momento. Vuelva a intentarlo en un momento.",
    "consult.room.status.scheduled": "Esperando que inicie la sesión.",
    "consult.room.status.in_progress": "Sesión en curso.",
    "consult.room.status.computing": "Calculando el monto…",
    "consult.room.status.computed": "Monto calculado.",
    "consult.room.status.captured": "Pago cobrado.",
    "consult.room.status.void_no_show": "Consulta cancelada por ausencia.",
    "consult.room.status.cancelled": "Consulta cancelada.",
    "consult.room.status.readyToJoin": "Puede unirse a la consulta.",
    "consult.room.status.waitingAuth": "Esperando la autorización del pago.",
    "consult.room.status.blockCompleted": "Esta consulta ha terminado.",
    "consult.room.waitingAuth.waiting": "Esperando la autorización del pago — {elapsed}.",
    "consult.room.waitingAuth.confirming": "Esto está tardando un poco más de lo habitual. Estamos confirmando el pago con el emisor de su tarjeta — mantenga esta página abierta.",
    "consult.room.duration.seconds": "{count} s",
    "consult.room.duration.minutes": "{count} min",
    "consult.room.endingSoon": "El tiempo reservado termina a las {when} — quedan {remaining}.",
    "consult.room.overrun.notice": "El tiempo reservado terminó a las {when}. La sala permanece abierta {remaining} más.",
    "consult.room.solo.patient": "Está solo en la sala. Si nadie se une, se le desconectará en {remaining}.",
    "consult.room.solo.practitioner": "Está solo en la sala: su cliente aún no se ha conectado. Si no se une nadie más, se le desconectará en {remaining}.",
    "consult.room.ejected.notice": "Se le desconectó por estar solo demasiado tiempo en la sala. La sala sigue abierta, puede volver a entrar.",
    "consult.room.ejected.rejoin": "Volver a la sala",
    "consult.room.closed.panel": "El tiempo reservado ha terminado: esta sala ya está cerrada.",
    "consult.room.closed.hint": "Ya no es posible volver a entrar. Para continuar, concierte otra cita con el consultorio.",
    "consult.room.joinState.opensAt": "Pago autorizado — su sala abre el {when}.",
    "consult.room.joinState.blockOpensAt": "Su sala abre el {when}.",
    "consult.room.joinState.blockNotPaid": "Esta consulta aún no se ha pagado. Complete el pago para acceder.",
    "consult.room.joinState.notYetOpen": "Pago autorizado — su sala aún no está abierta.",
    "consult.room.joinState.closed": "La sala de esta consulta está cerrada. Contacte con la consulta para concertar una nueva cita.",
    "consult.room.capReached": "Esta consulta alcanzó su límite autorizado. La facturación se detuvo; la sesión puede continuar.",
    "consult.room.authFailed.practitioner": "Acción de pago requerida — la autorización de su cliente falló. La consulta no puede iniciar hasta obtener una nueva autorización.",
    "consult.room.ended.confirmation": "Gracias — puede cerrar esta página con seguridad.",
    "consult.room.ended.backToPractice": "Volver al sitio del consultorio",
  },
};
